import React, { useContext, useEffect, useState } from "react";

import AuthContext from "../../context/AuthContext";

import "./MainSection.css";
import Container from "../../components/ui/Container";

import OffsetButton from "../../components/ui/Buttons/OffsetButton";
import { ReactComponent as Trophy } from "../../assets/monqez-assets/trophy_2784549.svg";
import { ReactComponent as DashLine1 } from "../../assets/monqez-assets/dashLine.svg";
import { ReactComponent as DashLine2 } from "../../assets/monqez-assets/dash_line2.svg";
import { ReactComponent as DashLine3 } from "../../assets/monqez-assets/dash_line3.svg";
import telawahHeroImg from "../../assets/telawah-assets/HeroImg.png";
import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranIconBtn.svg";
import Pattern from "../../assets/telawah-assets/heroBgPattern.svg";
import "./Heroimage.css";

import { ReactComponent as TextDecore } from "../../assets/monqez-assets/scratch.svg";
import { useLanguage } from "../../context/LanguageContext";
const MainSection = ({ title = "", id = 0 }) => {
    const { language } = useLanguage();
    const content = {
        heading: {
            en: {
                prefix: "Platform",
                highlight: "Telawah",
            },
            ar: {
                prefix: "مع منصة",
                highlight: "تلاوة",
            },
        },
        subheading: {
            en: "An all-in-one platform for learning Quran, exploring Islamic teachings, and fostering spiritual growth for everyone.",
            ar: "تلاوة: منصة شاملة لتعليم القرآن وتعاليم الإسلام لجميع الأعمار.",
        },
        button: {
            subscribe: {
                en: "Listen for free",
                ar: "استمع مجانًا",
            },
            myCourses: {
                en: "My Courses",
                ar: "كورساتي",
            },
        },
    };
    const { token } = useContext(AuthContext);

    return (
        <>
            <section className="md:h-screen min-h-screen negative-nav-margin relative overflow-hidden">
                <div
                    className="right-0 top-0 bottom-0 h-full w-full z-0 absolute opacity-80 dark:opacity-20 smooth"
                    style={{
                        backgroundImage: "url(" + Pattern + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "repeat-both",
                    }}
                ></div>
                <Container className="h-full relative z-10 font-fs pt-32 md:pt-0 pb-20 md:pb-0">
                    <div
                        className={`w-full flex ${
                            language === "en" ? "md:flex-row" : "md:flex-row-reverse"
                        }   flex-col h-full space-y-10 md:space-y-0 `}
                    >
                        <div className="md:basis-1/2 px-0 md:px-10 basis-full h-full flex-center-both">
                            <div
                                className={`flex md:items-start items-center justify-center flex-col space-y-6 md:space-y-0 ${
                                    language === "en" ? "en" : "ar"
                                }`}
                            >
                                <div className="relative">
                                    <div className="relative z-10 ">
                                        <div className="pt-3">
                                            <h1 className="text-5xl relative lg:text-6xl xl:text-8xl clr-text-primary smooth">
                                                <span className="font-Amiri text-accentBlue font-w-bold text-[2.5rem] lg:text-[4.5rem]">
                                                    {content.heading[language].prefix}{" "}
                                                    <span className="text-ashGray-500">
                                                        {content.heading[language].highlight}
                                                    </span>
                                                </span>
                                            </h1>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={`pt-6 text-center ${
                                        language === "en" ? "md:text-left" : "md:text-right"
                                    }  text-xl md:text-3xl w-3/4 text-gray-600 dark:text-gray-200 smooth space-y-2 flex-center-both flex-col font-lama`}
                                >
                                    {content.subheading[language]}
                                </div>

                                <div className=" pt-20 md:pb-0 w-fit  ">
                                    <OffsetButton
                                        color="earthYellow"
                                        className="flex-center-both text-lg gap-4"
                                        to={!token ? `/register` : "/me/user/courses"}
                                    >
                                        <QuranIcon className="mb-1 w-7 h-full " />
                                        {!token
                                            ? content.button.subscribe[language]
                                            : content.button.myCourses[language]}
                                    </OffsetButton>
                                </div>
                            </div>
                        </div>
                        <div className="md:basis-1/2 basis-full h-full flex-center-both pt-10 md:pt-0">
                            <div className="flex-center-both max-w-2xl px-4 sm:px-20">
                                <img src={telawahHeroImg} alt={"profile"} className="" />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default MainSection;
